import { makeStyles } from "@material-ui/core";

export const useRecommendedLanguageStyles = makeStyles(() => ({
    checkboxWrapper: {
        marginTop: 12
    }
}));
